module.exports = __webpack_public_path__ + "img/yao_zi.8d09db0e.png";